import { Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { isEmpty, Toast } from "../../../lib/helpers/helpers";
import { AppButton, AppSelect } from "../../../lib/styles/styleLibrary";
import { UploadWeddingPostImages } from "../../../redux/actions/media";
import { postToWeddingTimeline } from "../../../redux/actions/timeline";
import EmptyData from "../../EmptyData/EmptyData";
import { Loading, PageLoading } from "../../Loading/Loading";
import UploadImage from "../../UploadImage/UploadImage";
import { CreateTimelineWrapper } from "./component";

const CreateTimelinePost = (props) => {
	const {
		upcomingWeddings,
		upcomingLoading,
		refetch = () => {
			return null;
		},
		setVisible = () => {
			return null;
		},
	} = props;
	const Option = Select.Option;
	const { TextArea } = Input;

	const [imageUrls, setImageUrls] = useState([]);
	const [selected, setSelected] = useState("");
	useEffect(() => {
		setFields({ ...fields, media: imageUrls });
		// eslint-disable-next-line
	}, [imageUrls]);

	useEffect(() => {
		upcomingWeddings?.map((wed, i) => {
			if (wed.id === selected) {
				setFields({
					...fields,
					weddingId: wed.id,
					event_code: wed.event_code,
				});
				return true;
			}
			return false;
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selected]);

	const [fields, setFields] = useState({
		weddingId: "",
		post_text: "",
		event_code: "",
		media: [],
	});

	const { mutateAsync: handleCreate, isLoading } = useMutation(
		postToWeddingTimeline
	);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (isEmpty(fields.weddingId) || isEmpty(fields.event_code)) {
			Toast.fire({
				icon: "error",
				title: `Please select a wedding to post`,
			});
			return;
		}
		if (isEmpty(fields.media)) {
			Toast.fire({
				icon: "error",
				title: `No media was uploaded for this post`,
			});
			return;
		}

		try {
			const res = await handleCreate(fields);
			console.log(res);
			const { hasError } = res;
			if (hasError) {
				return Toast.fire({
					icon: "error",
					title: res.errors.message,
				});
			}

			Toast.fire({
				icon: "success",
				title: res.message,
			});
			setImageUrls([]);
			setSelected("");
			setFields({
				weddingId: "",
				post_text: "",
				event_code: "",
				media: [],
			});
			refetch();
			setVisible(false);
		} catch (error) {
			console.log("post tot timeline error", error);
		}
	};

	return (
		<CreateTimelineWrapper hide={props.hideOnMobile}>
			{upcomingLoading ? (
				<PageLoading />
			) :  isEmpty(upcomingWeddings) ? (
				<EmptyData description={"You are yet to join a wedding..."} />
			) : (
				<>
					<h3
						tw="font-semibold opacity-80 tracking-wide"
						style={{ fontSize: "0.875rem" }}>
						Create a timeline post
					</h3>
					<div tw="mt-4">
						<AppSelect
							value={selected}
							bordered={false}
							onChange={(value) => {
								setSelected(value);
							}}
							placeholder={"Select preferred document type"}
							tw="text-sm!">
							<Option value="" tw="text-sm">
								Select Wedding
							</Option>
							{upcomingWeddings?.map((wed, i) => {
								return (
									<Option value={wed.id} tw="text-sm" key={i}>
										{wed.bride_firstname} {" & "}
										{wed.groom_firstname}
									</Option>
								);
							})}
						</AppSelect>
					</div>
					<div tw="mt-4">
						<TextArea
							placeholder="Caption"
							autoSize={{ minRows: 2 }}
							tw="mb-4 text-xs p-3 rounded-lg"
							value={fields.post_text}
							onChange={(e) =>
								setFields({
									...fields,
									post_text: e.target.value,
								})
							}
						/>
					</div>
					<div tw="mt-4">
						{" "}
						<UploadImage
							setImageUrlList={setImageUrls}
							imageUrlList={imageUrls}
							uploadAPI={UploadWeddingPostImages}
							multiple
							maxCount={8}
							buttonWidth={"100%"}
							tw="border-none! p-0! m-0! h-auto!"
							disabled={isEmpty(fields.weddingId)}
							credentials={fields.weddingId}
						/>
					</div>
					<div tw="mt-8 mb-8">
						<AppButton tw="rounded-md" onClick={handleSubmit}>
							{isLoading ? <Loading /> : "Create"}
						</AppButton>
					</div>{" "}
				</>
			)}
		</CreateTimelineWrapper>
	);
};

export default CreateTimelinePost;
